import React, { Component } from 'react';
import './index.scss';

import Grid from 'material-ui/Grid';

import {observer,inject} from 'mobx-react';

@inject("summaryDataStore")
@observer
class SolarPackage extends Component {

    constructor(props){
        super(props)
        this.state = {
            isSelect: false,
            additionalPrice: 0
        }
    }

    changePackage(id) {
        this.props.summaryDataStore.changePackage(id);
    }

    _renderCardPackage(id, powerGeneration, additionalPrice, isSelect) {
        const { subType, defaultSolarPackageId } = this.props.summaryDataStore;

        let nameDefaultPackage = 'ติดตั้งฟรีพร้อมบ้าน';
        if(subType !== 'บ้านเดี่ยว') {
            nameDefaultPackage = 'ติดตั้งฟรีพร้อมโครงการ';
        }
        return (
            <Grid xs={4} sm={4} md={4} key={'Package'+id} onClick={()=>this.changePackage(id)} className="grid" spacing={0}>
                <div className='test'>
                    <div className={isSelect ? 'cardSelectStyle' : 'cardNotSelect'}>
                        <br/>
                        <span className='kwNumber'>{powerGeneration}</span>
                        <br/>
                        <span className='kw'> kWp</span>
                        <br/>
                        <br/>
                        <span>
                            {
                                defaultSolarPackageId === id ? nameDefaultPackage : 'เพิ่ม '+this.props.summaryDataStore.format_(additionalPrice)+' บาท'
                            }
                        </span>
                    </div>
                </div>
            </Grid>
        );
    }

    render() {
        const { packages, idSelected } = this.props.summaryDataStore;
        let { isSelect } = this.state;
        return (
            <div className='SolarPackage' >
                <Grid container className='containerGrid' spacing={0}>
                    {
                        packages.map((data) => {
                            if(data.id === idSelected){
                                isSelect = true;
                            } else {
                                isSelect = false;
                            }
                            // additionalPrice = this.props.summaryDataStore.calPriceOfSolar(data.powerGeneration)
                            return(
                                this._renderCardPackage(data.id,data.powerGeneration,data.additionalPrice,isSelect)
                            )
                        })
                    }
                </Grid>
            </div>
        );
    }
}

export default SolarPackage;


// WEBPACK FOOTER //
// ./src/components/accessories/solarPackage.js